<template>
  <div class="recommend">
    <step-header
      :title="headerTitle"
      :subtitle="locationName"
    />
    <div class="body">
      <div class="survey-screen">
        <div
          id="recommend-prompt"
          class="prompt"
        >
          {{ surveyTitle }}
        </div>
        <div
          role="group"
          aria-labelledby="recommend-prompt"
        >
          <pp-button
            class="btn btn-no-recommend"
            type="secondary"
            text="No"
            data-cy="recommend-no"
            @click="onNo"
          />
          <pp-button
            class="btn btn-yes-recommend"
            type="primary"
            text="Yes"
            data-cy="recommend-yes"
            @click="onYes"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StepHeader from '@/components/StepHeader/StepHeader.vue'
import { RECOMMEND_QUESTION } from '@/constants'
import { trackView, trackClick, trackSubmit } from '@/analytics'

export default {
  name: 'Recommend',
  components: { StepHeader },
  data () {
    return {
      surveyTitle: RECOMMEND_QUESTION
    }
  },
  computed: {
    ...mapGetters({
      headerTitle: 'reputation/headerTitle',
      locationName: 'reputation/locationName',
      wouldRecommend: 'reputation/wouldRecommend',
      analyticsDims: 'reputation/analyticsDims'
    })
  },
  created () {
    if (this.wouldRecommend !== null) {
      this.$router.replace({ name: 'ReviewDestination' })
      return
    }
    trackView(this, 'recommend_screen', this.analyticsDims)
  },
  methods: {
    ...mapActions({
      setWouldRecommend: 'reputation/setWouldRecommend',
      trackCampaignResponse: 'reputation/trackCampaignResponse'
    }),
    onYes () {
      trackClick(this, 'Yes!', this.analyticsDims)
      trackSubmit(this, 'would_recommend', this.analyticsDims)
      this.setWouldRecommend(true)
      // Tracking is non-fatal and the client has no timeout, so navigation
      // must not wait on the campaign POST.
      this.trackCampaignResponse()
      this.$router.push({ name: 'ReviewDestination' })
    },
    onNo () {
      trackClick(this, 'No', this.analyticsDims)
      trackSubmit(this, 'would_not_recommend', this.analyticsDims)
      this.setWouldRecommend(false)
      this.trackCampaignResponse()
      this.$router.push({ name: 'ReviewDestination' })
    }
  }
}
</script>

<style lang="scss" scoped>
.survey-screen {
  padding: 10px 0;
  text-align: center;

  @include mobile {
    padding: 50px 0;
  }
}

.prompt {
  color: $text-primary;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  height: 36px;
  margin: 12px 10px 0;
  width: 174px;
}
</style>
